import {infoPanelActionTypes} from './infoPanel-action-types';
import {authorizedRequest} from '../../common/request';

export const infoPanelSetAsset = (asset) => {

    return {
        type: infoPanelActionTypes.INFO_PANEL_SET_ASSET,
        asset
    };
};

export const setAssetRotation = (rotation) => {

    return {
        type: infoPanelActionTypes.INFO_PANEL_SET_ROTATION,
        rotation
    };
};

export const updateAsset = (dispatch, state) => {
    const updateData = state.form;
    const id = state.assetId;
    if (state.packageId === 0) {

        authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cces/${id}`, updateData, 'PUT')
            .then(() => dispatch(assetUpdateSuccess(id, updateData)))
            .catch(error => dispatch(assetUpdateFailed(error)));
        return {
            type: infoPanelActionTypes.INFO_PANEL_ASSET_UPDATE_REQUEST_ALBUM,
            id,
            updateData
        };
    } else {

        let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
        uri += state.discPackageType === 'PhotoCdPackage' ? 'pcdsp' : 'dvdchap';
        uri += "/" + id;
        authorizedRequest(uri, updateData, "PUT")
            .then(() => dispatch(assetUpdateSuccess(id, updateData)))
            .catch(error => dispatch(assetUpdateFailed(error)));
        return {
            type: infoPanelActionTypes.INFO_PANEL_ASSET_UPDATE_REQUEST_DISC,
            id,
            updateData
        };
    }


};

export const assetUpdateSuccess = (id, updateData) => {

    return {
        type: infoPanelActionTypes.INFO_PANEL_ASSET_UPDATE_SUCCESS,
        id,
        updateData
    };
};

export const assetUpdateFailed = (error) => {

    return {
        type: infoPanelActionTypes.INFO_PANEL_ASSET_UPDATE_FAIL,
        error
    };
};





// WEBPACK FOOTER //
// ./src/infoPanel/actions/infoPanel-actions.js